import React, { FC } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';

import MarkerContainer from './MarkerContainer/MarkerContainer';
import MarkerSummaryLoader from './MarkerSummaryLoader/MarkerSummaryLoader';
import MarkerSummaryDetails from './MarkerSummaryDetails/MarkerSummaryDetails';

const MarkerSummaryDetailsDefault = () => {
  const { url } = useParams<{ url: string }>();
  return <MarkerSummaryDetails url={url} />;
};

const MarkerDetailsDefault = () => {
  const { id, markerType } = useParams<{ id: string; markerType: string }>();
  return <MarkerContainer id={id} markerType={markerType} />;
};

const MarkerSummaryLoaderDefault = () => {
  const { id, markerType } = useParams<{ id: string; markerType: string }>();
  return <MarkerSummaryLoader id={id} markerType={markerType} />;
};

const MarkersFeature: FC = () => (
  <Switch>
    <Route path="/maps/marker/view/:markerType/:id">
      <MarkerDetailsDefault />
    </Route>

    <Route path="/maps/marker/summary/details/:url">
      <MarkerSummaryDetailsDefault />
    </Route>

    <Route path="/maps/marker/summary/:markerType/:id">
      <MarkerSummaryLoaderDefault />
    </Route>
  </Switch>
);

export default MarkersFeature;
